import React from 'react';
import { MyOpportunities } from './MyOpportunities';

export const MyOpportunitiesFactory = ({ widgetInformation }) => {
  const title = widgetInformation.config.title;
  return <MyOpportunities title={title} />;
};
